
document.addEventListener("DOMContentLoaded", () => {
  const menu = document.querySelector(".menu-button");
  const nav = document.querySelector(".main-nav");
  if (menu && nav) {
    const headerInner = document.querySelector(".header-inner-commerce");
    const positionNav = () => {
      const rect = headerInner?.getBoundingClientRect();
      const top = Math.max(0, Math.round(rect?.bottom || 78));
      const left = Math.max(13, Math.round(rect?.left || 13));
      nav.style.setProperty("--jfab-menu-top", `${top}px`);
      nav.style.setProperty("--jfab-menu-left", `${left}px`);
    };
    const closeSubmenus = () => {
      nav.querySelectorAll(".nav-item.submenu-open").forEach(item => {
        item.classList.remove("submenu-open");
        const button = item.querySelector(":scope > .nav-parent-toggle");
        const submenu = item.querySelector(":scope > .submenu");
        if (button) {
          button.setAttribute("aria-expanded", "false");
          button.setAttribute("aria-label", `Open ${button.querySelector(".nav-parent-label")?.textContent.trim() || ""} submenu`);
        }
        if (submenu) submenu.hidden = true;
      });
    };
    const closeMenu = () => {
      nav.classList.remove("open");
      menu.setAttribute("aria-expanded", "false");
      menu.setAttribute("aria-label", "Open menu");
      closeSubmenus();
    };

    // Keep the drawer out of the sticky header's containing block so its
    // fixed height can use the visible viewport on laptops and phones.
    document.body.appendChild(nav);
    menu.addEventListener("click", () => {
      positionNav();
      const open = nav.classList.toggle("open");
      menu.setAttribute("aria-expanded", String(open));
      menu.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      if (!open) closeSubmenus();
    });
    window.addEventListener("resize", () => { if (nav.classList.contains("open")) positionNav(); });
    window.addEventListener("scroll", () => { if (nav.classList.contains("open")) positionNav(); }, { passive: true });
    document.addEventListener("keydown", event => {
      if (event.key === "Escape" && nav.classList.contains("open")) {
        closeMenu();
        menu.focus();
      }
    });
    document.addEventListener("click", event => {
      if (!nav.classList.contains("open")) return;
      if (event.target.closest(".main-nav") || event.target.closest(".menu-button")) return;
      closeMenu();
    });
  }
  document.querySelectorAll("[data-year]").forEach(el => el.textContent = new Date().getFullYear());

  document.querySelectorAll(".nav-parent-toggle").forEach(button => {
    button.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      const item = button.closest(".nav-item");
      const submenu = item ? item.querySelector(":scope > .submenu") : null;
      if (!item || !submenu) return;

      const willOpen = !item.classList.contains("submenu-open");
      item.classList.toggle("submenu-open", willOpen);
      button.setAttribute("aria-expanded", String(willOpen));
      button.setAttribute("aria-label", `${willOpen ? "Close" : "Open"} ${button.querySelector(".nav-parent-label")?.textContent.trim() || ""} submenu`);
      submenu.hidden = !willOpen;
    });
  });

  document.addEventListener("click", event => {
    if (window.matchMedia("(max-width: 940px)").matches) return;
    if (event.target.closest(".nav-item")) return;
    document.querySelectorAll(".nav-item.submenu-open").forEach(item => {
      item.classList.remove("submenu-open");
      const button = item.querySelector(":scope > .nav-parent-toggle");
      const submenu = item.querySelector(":scope > .submenu");
      if (button) button.setAttribute("aria-expanded", "false");
      if (submenu) submenu.hidden = true;
    });
  });

  document.querySelectorAll(".faq-question").forEach(button => {
    button.addEventListener("click", () => {
      const item = button.closest(".faq-item");
      item.classList.toggle("open");
      button.setAttribute("aria-expanded", String(item.classList.contains("open")));
    });
  });

  const filters = document.querySelectorAll("[data-filter]");
  const cards = document.querySelectorAll("[data-category]");
  filters.forEach(btn => {
    btn.addEventListener("click", () => {
      filters.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      const value = btn.dataset.filter;
      cards.forEach(card => {
        const cats = (card.dataset.category || "").split(" ");
        card.hidden = value !== "all" && !cats.includes(value);
      });
    });
  });

  const fileInput = document.querySelector("#project-files");
  const fileList = document.querySelector("#file-list");
  if (fileInput && fileList) {
    fileInput.addEventListener("change", () => {
      fileList.innerHTML = "";
      [...fileInput.files].slice(0,8).forEach(file => {
        const row = document.createElement("div");
        row.className = "file-item";
        row.innerHTML = `<span>${file.name}</span><span>${Math.ceil(file.size/1024)} KB</span>`;
        fileList.appendChild(row);
      });
    });
  }
});

// Show a clear confirmation after a successful launch-list signup.
(() => {
  const form = document.querySelector("#launch-list-form");
  if (!form) return;
  const params = new URLSearchParams(window.location.search);
  if (params.get("joined") !== "true") return;
  form.innerHTML = `
    <div class="launch-list-confirmation full" role="status" tabindex="-1">
      <p class="eyebrow">YOU'RE ON THE LIST</p>
      <h2>THANK YOU FOR JOINING.</h2>
      <p>Your interest has been saved. J Fab will send new-product and first-batch updates—not daily email.</p>
      <a class="button button-primary" href="/collections/all">Browse the Shop</a>
    </div>`;
  const confirmation = form.querySelector(".launch-list-confirmation");
  if (confirmation) confirmation.focus();
})();

// v9 header search and local favorites drawer.
document.addEventListener('DOMContentLoaded', () => {
  const KEY = 'jfab_wishlist_v1';
  const getItems = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };
  const saveItems = items => localStorage.setItem(KEY, JSON.stringify(items));
  const drawer = document.querySelector('#wishlist-drawer');
  const overlay = document.querySelector('.drawer-overlay');
  const openButton = document.querySelector('.wishlist-toggle');
  const closeButton = document.querySelector('.wishlist-close');
  const itemsNode = document.querySelector('[data-wishlist-items]');
  const emptyNode = document.querySelector('[data-wishlist-empty]');
  const countNode = document.querySelector('.wishlist-count');

  // Keep every modal drawer outside the sticky header's stacking context so
  // the page overlay cannot sit on top of drawer controls.
  [
    drawer,
    document.querySelector('#account-drawer'),
    document.querySelector('#garage-drawer'),
    overlay
  ].forEach(element => {
    if (element) document.body.appendChild(element);
  });

  function updateButtons(items) {
    const handles = new Set(items.map(i => i.handle));
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const saved = handles.has(btn.dataset.productHandle);
      btn.classList.toggle('is-saved', saved);
      btn.textContent = saved ? '♥' : '♡';
      btn.setAttribute('aria-pressed', String(saved));
    });
  }
  document.addEventListener('jfab:products-rendered', () => updateButtons(getItems()));
  function render() {
    const items = getItems();
    if (countNode) { countNode.textContent = items.length; countNode.hidden = items.length === 0; }
    if (emptyNode) emptyNode.hidden = items.length > 0;
    if (itemsNode) {
      itemsNode.innerHTML = items.map(item => `
        <article class="wishlist-item" data-handle="${item.handle}">
          ${item.image ? `<img src="${item.image}" alt="">` : '<div></div>'}
          <div><h3><a href="${item.url}">${item.title}</a></h3><p>${item.price || ''}</p></div>
          <button class="wishlist-remove" type="button" data-wishlist-remove="${item.handle}" aria-label="Remove ${item.title}">×</button>
        </article>`).join('');
    }
    updateButtons(items);
  }
  function openDrawer() { if (!drawer || !overlay) return; drawer.hidden = false; overlay.hidden = false; openButton?.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; }
  function closeDrawer() { if (!drawer || !overlay) return; drawer.hidden = true; overlay.hidden = true; openButton?.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
  openButton?.addEventListener('click', () => { render(); openDrawer(); });
  closeButton?.addEventListener('click', closeDrawer); overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  document.addEventListener('click', event => {
    const saveForLater = event.target.closest('[data-cart-save-for-later]');
    if (saveForLater) {
      event.preventDefault();
      const items = getItems();
      const handle = saveForLater.dataset.productHandle;
      if (!items.some(item => item.handle === handle)) {
        items.push({
          handle,
          title: saveForLater.dataset.productTitle,
          url: saveForLater.dataset.productUrl,
          image: saveForLater.dataset.productImage,
          price: saveForLater.dataset.productPrice
        });
      }
      saveItems(items);
      render();
      saveForLater.disabled = true;
      saveForLater.textContent = 'Saved';
      const removeUrl = saveForLater.dataset.removeUrl;
      if (removeUrl) window.location.assign(removeUrl);
      return;
    }
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      event.stopPropagation();
      const handle = remove.dataset.wishlistRemove;
      saveItems(getItems().filter(item => item.handle !== handle));
      render();
      return;
    }
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      let items = getItems();
      const handle = toggle.dataset.productHandle;
      const exists = items.some(i => i.handle === handle);
      if (exists) items = items.filter(i => i.handle !== handle);
      else items.push({ handle, title: toggle.dataset.productTitle, url: toggle.dataset.productUrl, image: toggle.dataset.productImage, price: toggle.dataset.productPrice });
      saveItems(items); render();
      return;
    }
  });
  render();
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-development-description]').forEach(description => {
    description.querySelectorAll('p').forEach(paragraph => {
      const text = paragraph.textContent.replace(/\s+/g, ' ').trim();
      const normalized = text.toLowerCase();
      if (normalized === 'development product — not yet available' || normalized === 'coming soon — in development') {
        paragraph.remove();
      }
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(form => {
    const variantsNode = form.querySelector('[data-product-variants]');
    const moneyNode = form.querySelector('[data-money-format]');
    if (!variantsNode) return;
    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch { return; }
    let moneyFormat = '${{amount}}';
    try { moneyFormat = JSON.parse(moneyNode?.textContent || '"${{amount}}"'); } catch {}

    const selects = [...form.querySelectorAll('[data-option-index]')];
    const variantInput = form.querySelector('[data-variant-id]');
    const priceNode = form.querySelector('[data-configured-price]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const mainPriceNode = document.querySelector('[data-main-product-price]');
    const customerPartNumberNode = document.querySelector('[data-customer-part-number]');
    const customerPartNumberValueNode = document.querySelector('[data-customer-part-number-value]');
    const isDevelopmentProduct = form.dataset.developmentProduct === 'true';
    const singleVariantFinishFallback = form.dataset.singleVariantFinishFallback === 'true';
    const defaultColorKey = form.dataset.defaultColorKey || 'factory-red';
    const priceTbdLabel = form.dataset.priceTbdLabel || 'Pricing in development';
    const colorSelect = form.querySelector('[data-product-color-preview], [data-product-color-option]');
    const finishTierSelect = form.querySelector('[data-product-finish-tier]');
    const colorGallery = document.querySelector('[data-product-color-gallery]');
    const colorCatalogNode = document.querySelector('[data-product-color-catalog]');
    const colorGalleryNote = document.querySelector('[data-product-color-gallery-note]');
    const colorBrowser = document.querySelector('[data-product-color-browser]');
    const specialOrderNotice = form.querySelector('[data-special-order-notice]');
    const specialOrderColorField = form.querySelector('[data-special-order-color-field]');
    const specialOrderColorInput = form.querySelector('[data-special-order-color-input]');
    const specialOrderProperty = form.querySelector('[data-special-order-property]');
    const colorMatchDisclaimer = form.querySelector('[data-color-match-disclaimer]');
    const colorMatchProperty = form.querySelector('[data-color-match-property]');
    const finishCodeProperty = form.querySelector('[data-finish-code-property]');
    const partNumberProperty = form.querySelector('[data-part-number-property]');
    const bundleOffer = form.querySelector('[data-radius-bundle]');
    const bundleToggle = form.querySelector('[data-radius-bundle-toggle]');
    const bundleDelta = form.querySelector('[data-radius-bundle-delta]');
    const bundleDetails = form.querySelector('[data-radius-bundle-details]');
    const bundleConfiguration = form.querySelector('[data-radius-bundle-configuration]');
    const bundleVariantsNode = form.querySelector('[data-product-bundle-variants]');
    const bundleOptionsNode = form.querySelector('[data-product-bundle-options]');
    const bundleMatchingVariantsNode = form.querySelector('[data-product-bundle-matching-variants]');
    const bundleMatchingOptionsNode = form.querySelector('[data-product-bundle-matching-options]');
    const switchPanelGallery = document.querySelector('[data-switch-panel-gallery]');
    const switchQuantitySelect = selects.find(select => /switch/i.test(select.dataset.optionName || ''));
    const fitmentSelect = form.querySelector('[data-sxs-fitment]');
    let bundleVariants = [];
    let bundleOptionNames = [];
    let bundleMatchingVariants = [];
    let bundleMatchingOptionNames = [];
    try { bundleVariants = JSON.parse(bundleVariantsNode?.textContent || '[]'); } catch {}
    try { bundleOptionNames = JSON.parse(bundleOptionsNode?.textContent || '[]'); } catch {}
    try { bundleMatchingVariants = JSON.parse(bundleMatchingVariantsNode?.textContent || '[]'); } catch {}
    try { bundleMatchingOptionNames = JSON.parse(bundleMatchingOptionsNode?.textContent || '[]'); } catch {}
    const bundleRequestedFromUrl = new URL(window.location.href).searchParams.get('bundle') === '1';
    if (bundleToggle && bundleRequestedFromUrl) bundleToggle.checked = true;
    let activeVariant = null;
    let activeStandaloneVariant = null;

    let powderColors = {};
    try { powderColors = JSON.parse(colorCatalogNode?.textContent || '{}'); } catch {}
    const normalizeColor = value => String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[–—]/g, '-')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    const colorAliases = new Map();
    Object.entries(powderColors).forEach(([key, powder]) => {
      [key, powder.label, powder.powder, ...(powder.aliases || [])].forEach(alias => {
        colorAliases.set(normalizeColor(alias), key);
      });
    });
    const colorKey = value => colorAliases.get(normalizeColor(value)) || defaultColorKey;
    const swatchAssetsNode = document.querySelector('[data-color-swatch-assets]');
    const finishSelects = [...form.querySelectorAll('[data-product-color-option], [data-product-color-preview]')];
    const finishSwatchKey = value => {
      const normalized = normalizeColor(value);
      if (/bare|raw|unfinished|uncoated/.test(normalized)) return 'bare';
      if (/honda talon blue/.test(normalized)) return 'talonBlue';
      if (/polaris velocity blue/.test(normalized)) return 'velocityBlue';
      if (/polaris zenith blue/.test(normalized)) return 'zenithBlue';
      if (/polaris voodoo blue/.test(normalized)) return 'voodooBlue';
      if (/kawasaki/.test(normalized) && /green/.test(normalized)) return 'kawasakiGreen';
      if (/black/.test(normalized)) return 'black';
      if (/bronze/.test(normalized)) return 'bronze';
      if (/orange/.test(normalized)) return 'orange';
      if (/red/.test(normalized)) return 'red';
      if (/white/.test(normalized)) return 'white';
      return '';
    };
    const updateColorSwatches = () => {
      finishSelects.forEach(select => {
        let shell = select.closest('[data-color-select-shell]');
        if (!shell) {
          shell = document.createElement('span');
          shell.className = 'product-color-select-shell';
          shell.dataset.colorSelectShell = '';
          select.parentNode.insertBefore(shell, select);
          shell.appendChild(select);
        }
        let preview = shell.querySelector('[data-color-swatch-preview]');
        if (!preview) {
          preview = document.createElement('span');
          preview.className = 'product-color-selected-swatch';
          preview.dataset.colorSwatchPreview = '';
          preview.setAttribute('aria-hidden', 'true');
          shell.insertBefore(preview, select);
        }
        const key = finishSwatchKey(select.value);
        const asset = key && key !== 'bare' ? swatchAssetsNode?.dataset[`swatch${key.charAt(0).toUpperCase()}${key.slice(1)}`] : '';
        preview.classList.toggle('is-bare', key === 'bare');
        preview.classList.toggle('is-unknown', !key);
        preview.style.backgroundImage = asset ? `url("${asset}")` : '';
        preview.title = select.value ? `${select.value} finish sample` : 'Finish sample';
      });
    };
    const productGalleryImage = document.querySelector('.product-gallery-column .gallery > img');
    const productGalleryThumbs = [...document.querySelectorAll('.product-gallery-column .product-media-thumbs a')];
    const mediaColorKey = value => {
      const normalized = normalizeColor(value);
      if (/bare|raw|unfinished|uncoated/.test(normalized)) return 'bare steel';
      return normalized;
    };
    const showProductMedia = link => {
      if (!productGalleryImage || !link) return;
      const thumbImage = link.querySelector('img');
      const imageUrl = link.getAttribute('href');
      if (!imageUrl) return;
      productGalleryImage.removeAttribute('srcset');
      productGalleryImage.removeAttribute('sizes');
      productGalleryImage.src = imageUrl;
      if (thumbImage?.alt) productGalleryImage.alt = thumbImage.alt;
      productGalleryThumbs.forEach(thumb => thumb.classList.toggle('is-selected', thumb === link));
    };
    const updateProductMediaForColor = () => {
      if (!colorSelect || !productGalleryImage || !productGalleryThumbs.length) return;
      const wanted = mediaColorKey(colorSelect.value);
      if (!wanted) return;
      const match = productGalleryThumbs.find(link => {
        const alt = normalizeColor(link.querySelector('img')?.alt || '');
        return alt.includes(wanted) && /powder coat|bare steel/.test(alt);
      });
      if (match) showProductMedia(match);
    };
    productGalleryThumbs.forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        showProductMedia(link);
      });
    });
    const canonicalCheckoutTier = value => {
      const normalized = normalizeColor(value);
      if (/special/.test(normalized)) return 'special-order-powder';
      if (/bare|raw|unfinished|uncoated/.test(normalized)) return 'bare-steel';
      if (/standard/.test(normalized) && /powder|coat|finish/.test(normalized)) return 'standard-powder';
      if (/black/.test(normalized) && /powder|coat|finish/.test(normalized)) return 'standard-powder';
      if (normalized === 'powder coated' || normalized === 'powder coat') return 'standard-powder';
      return normalized.replace(/ /g, '-');
    };
    const selectedPowder = () => {
      if (!colorSelect) return null;
      return powderColors[colorKey(colorSelect.value)] || null;
    };
    const selectedCheckoutTier = () => {
      const optionTier = colorSelect?.selectedOptions?.[0]?.dataset.checkoutTier;
      const powder = selectedPowder();
      return canonicalCheckoutTier(optionTier || powder?.checkoutTier || powder?.priceTier || colorSelect?.value || '');
    };
    const updateProductionPartNumber = variant => {
      const powder = selectedPowder();
      const selectedOptionCode = colorSelect?.selectedOptions?.[0]?.dataset.finishCode || '';
      const finishCode = powder?.finishCode || selectedOptionCode;
      if (finishCodeProperty) finishCodeProperty.value = finishCode;
      if (!partNumberProperty) return;
      const variantSku = String(variant?.sku || '').trim();
      const basePartNumber = variantSku.replace(/-(?:BARE|STD|SPC)$/i, '');
      partNumberProperty.value = basePartNumber && finishCode
        ? `${basePartNumber}-${finishCode}`
        : variantSku;
    };
    const updateCustomerPartNumber = variant => {
      if (!customerPartNumberNode || !customerPartNumberValueNode) return;
      const variantSku = String(variant?.sku || '').trim();
      customerPartNumberNode.hidden = !variantSku;
      customerPartNumberValueNode.textContent = variantSku;
    };
    const finishTierIndex = finishTierSelect ? Number(finishTierSelect.dataset.optionIndex) : -1;
    const findStandaloneVariantForTier = tier => {
      const canonicalTier = canonicalCheckoutTier(tier);
      if (!finishTierSelect || finishTierIndex < 0) {
        if (singleVariantFinishFallback && variants.length === 1 && canonicalTier === 'standard-powder') return variants[0];
        return canonicalTier === 'bare-steel' && variants.length === 1 ? variants[0] : null;
      }
      const currentValues = selects.map(select => select.value);
      return variants.find(variant => variant.options.every((optionValue, index) => {
        if (index === finishTierIndex) return canonicalCheckoutTier(optionValue) === canonicalTier;
        return optionValue === currentValues[index];
      })) || null;
    };
    const canonicalBundleOptionName = value => {
      const normalized = normalizeColor(value);
      if (/finish|color|colour/.test(normalized)) return 'finish';
      if (/bushing/.test(normalized)) return 'bushing-package';
      if (/ball/.test(normalized) && /joint/.test(normalized)) return 'ball-joint-package';
      return normalized.replace(/ /g, '-');
    };
    const bundleOptionValuesMatch = (optionName, actual, expected) => {
      if (canonicalBundleOptionName(optionName) === 'finish') {
        return canonicalCheckoutTier(actual) === canonicalCheckoutTier(expected);
      }
      return normalizeColor(actual) === normalizeColor(expected);
    };
    const selectedSourceOptions = () => {
      const selected = new Map();
      selects.forEach(select => {
        const name = canonicalBundleOptionName(select.dataset.optionName || '');
        if (name) selected.set(name, select.value);
      });
      return selected;
    };
    const findRelatedVariantForTier = (relatedVariants, relatedOptionNames, tier) => {
      if (!relatedVariants.length) return null;
      if (!relatedOptionNames.length) return relatedVariants.length === 1 ? relatedVariants[0] : null;

      const sourceOptions = selectedSourceOptions();
      const requestedTier = canonicalCheckoutTier(tier);
      if (requestedTier) sourceOptions.set('finish', tier);

      return relatedVariants.find(variant => relatedOptionNames.every((optionName, optionIndex) => {
        const optionKey = canonicalBundleOptionName(optionName);
        const expectedValue = sourceOptions.get(optionKey);
        if (expectedValue !== undefined) {
          return bundleOptionValuesMatch(optionName, variant.options[optionIndex], expectedValue);
        }

        // A bundle-only option may be omitted from the source product only when
        // every bundle variant has the same value. Never guess among choices.
        const uniqueValues = new Map();
        relatedVariants.forEach(relatedVariant => {
          const value = relatedVariant.options[optionIndex];
          uniqueValues.set(normalizeColor(value), value);
        });
        if (uniqueValues.size !== 1) return false;
        return bundleOptionValuesMatch(optionName, variant.options[optionIndex], uniqueValues.values().next().value);
      })) || null;
    };
    const findBundleVariantForTier = tier => findRelatedVariantForTier(bundleVariants, bundleOptionNames, tier);
    const findMatchingStandaloneVariantForTier = tier => findRelatedVariantForTier(
      bundleMatchingVariants,
      bundleMatchingOptionNames,
      tier
    );
    const syncFinishTierFromColor = () => {
      if (!colorSelect || !finishTierSelect) {
        if (singleVariantFinishFallback && variants.length === 1) return selectedCheckoutTier() === 'standard-powder';
        return selectedCheckoutTier() === 'bare-steel';
      }
      const requestedTier = selectedCheckoutTier();
      const matchingOption = [...finishTierSelect.options].find(option =>
        canonicalCheckoutTier(option.value) === requestedTier
      );
      if (!matchingOption) return false;
      finishTierSelect.value = matchingOption.value;
      return true;
    };
    const updateColorGallery = () => {
      if (!colorSelect) return;
      const selectedKey = colorKey(colorSelect.value);
      const powder = powderColors[selectedKey] || powderColors[defaultColorKey] || powderColors['factory-red'];
      if (!powder) return;
      const renderKey = !powder.render || powder.render === 'default' ? defaultColorKey : powder.render;
      if (colorGallery) {
        const productImages = [...colorGallery.querySelectorAll('[data-product-color-image]')];
        const selectedImage = productImages.find(image => image.dataset.productColorImage === renderKey)
          || productImages.find(image => image.dataset.productColorImage === defaultColorKey)
          || productImages[0];
        productImages.forEach(image => { image.hidden = image !== selectedImage; });
      }
      if (colorGalleryNote) {
        colorGalleryNote.textContent = 'Swipe to view available finishes.';
      }
      if (colorMatchDisclaimer) colorMatchDisclaimer.hidden = !powder.closestMatch;
      if (colorMatchProperty) colorMatchProperty.disabled = !powder.closestMatch;
      colorBrowser?.querySelectorAll('[data-product-color-choice]').forEach(button => {
        const isSelected = button.dataset.productColorChoice === selectedKey;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
      });
    };
    const updateSpecialOrderState = variant => {
      let isSpecialOrder = false;
      if (colorSelect) {
        const powder = powderColors[colorKey(colorSelect.value)] || powderColors[defaultColorKey] || powderColors['factory-red'];
        isSpecialOrder = Boolean(powder?.specialOrder);
        if (specialOrderNotice) specialOrderNotice.hidden = !isSpecialOrder;
        if (specialOrderColorField) specialOrderColorField.hidden = !isSpecialOrder;
        if (specialOrderColorInput) {
          specialOrderColorInput.disabled = !isSpecialOrder;
          specialOrderColorInput.required = isSpecialOrder;
          if (!isSpecialOrder) specialOrderColorInput.value = '';
        }
        [specialOrderProperty].forEach(input => {
          if (input) input.disabled = !isSpecialOrder;
        });
      }
      if (!addButton || isDevelopmentProduct || !variant) return;
      const isAvailable = Boolean(variant?.available);
      const requestedColorEntered = !isSpecialOrder || Boolean(specialOrderColorInput?.value.trim());
      addButton.disabled = !isAvailable || !requestedColorEntered;
      addButton.textContent = !isAvailable
        ? (addButton.dataset.unavailableLabel || 'Unavailable')
        : (!requestedColorEntered
          ? 'Enter Requested Color'
          : 'Add to Cart');
    };

    const pageUrl = new URL(window.location.href);
    if (colorSelect && !pageUrl.searchParams.has('variant')) {
      const defaultOption = [...colorSelect.options].find(option => colorKey(option.value) === defaultColorKey);
      if (defaultOption) colorSelect.value = defaultOption.value;
    } else if (colorSelect && finishTierSelect && pageUrl.searchParams.has('variant')) {
      const requestedTier = canonicalCheckoutTier(finishTierSelect.value);
      const matchingColor = [...colorSelect.options].find(option =>
        canonicalCheckoutTier(option.dataset.checkoutTier || option.dataset.finishTier || option.value) === requestedTier
      );
      if (matchingColor) colorSelect.value = matchingColor.value;
    }

    colorBrowser?.addEventListener('click', event => {
      const button = event.target.closest('[data-product-color-choice]');
      if (!button || !colorSelect) return;
      const requestedKey = button.dataset.productColorChoice;
      const matchingOption = [...colorSelect.options].find(option => colorKey(option.value) === requestedKey);
      if (!matchingOption) return;
      colorSelect.value = matchingOption.value;
      colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const formatMoney = cents => {
      const value = Number(cents || 0);
      const amount = (value / 100).toFixed(2);
      const amountNoDecimals = Math.round(value / 100).toString();
      return moneyFormat
        .replace('{{amount}}', amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace('{{amount_no_decimals}}', amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    };

    const updateColorOptionPriceLabels = () => {
      if (!colorSelect || !finishTierSelect) return;
      const useBundlePrices = Boolean(bundleToggle?.checked && bundleVariants.length);
      const variantForTier = useBundlePrices ? findBundleVariantForTier : findStandaloneVariantForTier;
      const selectedTier = selectedCheckoutTier();
      const selectedPriceVariant = variantForTier(selectedTier);
      [...colorSelect.options].forEach(option => {
        if (!option.dataset.baseLabel) {
          option.dataset.baseLabel = option.textContent
            .split('·')[0]
            .replace(/\s+[—-]\s+(?:Included|Standard Powder|Special Order)$/i, '')
            .trim();
        }
        const tier = canonicalCheckoutTier(option.dataset.checkoutTier || option.dataset.finishTier || option.value);
        const pricedVariant = variantForTier(tier);
        const specialOrderCopy = tier === 'special-order-powder' ? ' · Special Order' : '';
        if (tier === selectedTier) {
          option.textContent = `${option.dataset.baseLabel}${specialOrderCopy}`;
          return;
        }
        if (!selectedPriceVariant || !pricedVariant) {
          option.textContent = `${option.dataset.baseLabel} · Pricing unavailable`;
          return;
        }
        const difference = Number(pricedVariant.price || 0) - Number(selectedPriceVariant.price || 0);
        const joinedSign = difference > 0 ? '+\u2060' : '-\u2060';
        const priceCopy = difference > 0
          ? ` (${joinedSign}${formatMoney(difference)})`
          : (difference < 0 ? ` (${joinedSign}${formatMoney(Math.abs(difference))})` : '');
        option.textContent = `${option.dataset.baseLabel}${priceCopy}${specialOrderCopy}`;
      });
    };

    const updateBundleOffer = standaloneVariant => {
      if (!bundleOffer || !bundleToggle) return standaloneVariant;
      const bundleVariant = findBundleVariantForTier(selectedCheckoutTier());
      const bundleReady = Boolean(standaloneVariant && bundleVariant && bundleVariant.available);
      bundleToggle.disabled = !bundleReady;
      bundleOffer.classList.toggle('is-unavailable', !bundleReady);
      if (!bundleReady) bundleToggle.checked = false;

      if (bundleDelta) {
        if (!bundleReady) {
          bundleDelta.textContent = 'Matching-set pricing unavailable for this configuration';
          if (bundleDetails) bundleDetails.textContent = 'Select an available configuration to see complete-set pricing.';
        } else {
          const matchingVariant = findMatchingStandaloneVariantForTier(selectedCheckoutTier());
          const bundlePrice = Number(bundleVariant.price || 0);
          const standalonePrice = Number(standaloneVariant.price || 0);
          const matchingPrice = Number(matchingVariant?.price || 0);
          const separateTotal = standalonePrice + matchingPrice;
          const savings = matchingPrice > 0 ? Math.max(0, separateTotal - bundlePrice) : 0;
          bundleDelta.textContent = `Complete set: ${formatMoney(bundlePrice)} total${savings > 0 ? ` · Save ${formatMoney(savings)}` : ''}`;
          if (bundleDetails) {
            const matchingLabel = bundleOffer.dataset.radiusBundleMatchingLabel || 'Matching pair';
            bundleDetails.textContent = matchingPrice > 0
              ? `${matchingLabel} sold separately: ${formatMoney(matchingPrice)}.`
              : 'Select this option for one complete upper-and-lower four-arm set.';
          }
        }
      }

      if (bundleConfiguration) {
        const sourceLabel = bundleOffer.dataset.radiusBundleSourceLabel || 'Standalone Pair';
        const completeLabel = bundleOffer.dataset.radiusBundleCompleteLabel || 'Complete Upper + Lower Set';
        bundleConfiguration.value = bundleToggle.checked
          ? completeLabel
          : sourceLabel;
      }
      return bundleToggle.checked && bundleReady ? bundleVariant : standaloneVariant;
    };

    const normalizeOptionValue = value => String(value || '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
    const requestedFitment = new URL(window.location.href).searchParams.get('fitment');
    if (requestedFitment) {
      const requestedValue = normalizeOptionValue(requestedFitment);
      const matchingOption = fitmentSelect
        ? [...fitmentSelect.options].find(option => normalizeOptionValue(option.value) === requestedValue)
        : null;
      if (fitmentSelect && matchingOption) fitmentSelect.value = matchingOption.value;
    }

    const showSwitchPanelMedia = switchCount => {
      if (!switchPanelGallery) return;
      const mediaNodes = [...switchPanelGallery.querySelectorAll('[data-switch-panel-media]')];
      const target = mediaNodes.find(media => media.dataset.switchPanelCount === String(switchCount));
      if (!target) return;
      mediaNodes.forEach(media => { media.hidden = media !== target; });
    };
    const updateSwitchPanelMedia = () => {
      if (!switchPanelGallery || !switchQuantitySelect) return;
      const selectedValue = normalizeOptionValue(switchQuantitySelect.value);
      const parsedCount = Number.parseInt(selectedValue.match(/\d+/)?.[0] || '0', 10);
      const switchCount = Math.min(6, Math.max(0, Number.isFinite(parsedCount) ? parsedCount : 0));
      showSwitchPanelMedia(switchCount);
    };

    function selectedValues() { return selects.map(select => select.value); }
    function update() {
      updateColorSwatches();
      updateProductMediaForColor();
      const isTieredColorProduct = Boolean(colorSelect && Object.keys(powderColors).length);
      const tierReady = !isTieredColorProduct || syncFinishTierFromColor();
      const values = selectedValues();
      const standaloneVariant = tierReady
        ? variants.find(item => values.every((value, index) => item.options[index] === value))
        : null;
      activeStandaloneVariant = standaloneVariant || null;

      if (!standaloneVariant) {
        activeVariant = null;
        if (variantInput) variantInput.value = '';
        updateProductionPartNumber(null);
        updateCustomerPartNumber(null);
        updateBundleOffer(null);
        updateColorOptionPriceLabels();
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = isTieredColorProduct
            ? 'Finish Pricing Unavailable'
            : (addButton.dataset.noVariantLabel || addButton.dataset.unavailableLabel || 'Unavailable');
        }
        updateColorGallery();
        updateSwitchPanelMedia();
        updateSpecialOrderState(null);
        return;
      }

      const purchaseVariant = updateBundleOffer(standaloneVariant) || standaloneVariant;
      updateColorOptionPriceLabels();
      activeVariant = purchaseVariant;
      if (variantInput) variantInput.value = purchaseVariant.id;
      updateProductionPartNumber(purchaseVariant);
      updateCustomerPartNumber(purchaseVariant);
      const purchasePrice = Number(purchaseVariant.price || 0);
      if (priceNode) priceNode.textContent = purchasePrice === 0 ? priceTbdLabel : formatMoney(purchasePrice);
      if (mainPriceNode) mainPriceNode.textContent = purchasePrice === 0 ? priceTbdLabel : formatMoney(purchasePrice);
      if (addButton) {
        addButton.disabled = isDevelopmentProduct || !purchaseVariant.available;
        addButton.textContent = isDevelopmentProduct
          ? (addButton.dataset.unavailableLabel || 'Not Yet Available')
          : (!purchaseVariant.available
            ? (addButton.dataset.unavailableLabel || 'Unavailable')
            : 'Add to Cart');
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', standaloneVariant.id);
      if (bundleToggle?.checked) url.searchParams.set('bundle', '1');
      else url.searchParams.delete('bundle');
      if (fitmentSelect?.value) url.searchParams.set('fitment', fitmentSelect.value);
      else url.searchParams.delete('fitment');
      window.history.replaceState({}, '', url);
      updateColorGallery();
      updateSwitchPanelMedia();
      updateSpecialOrderState(purchaseVariant);
    }
    selects.forEach(select => select.addEventListener('change', update));
    if (colorSelect && !colorSelect.matches('[data-option-index]')) {
      colorSelect.addEventListener('change', update);
    }
    specialOrderColorInput?.addEventListener('input', update);
    bundleToggle?.addEventListener('change', update);
    fitmentSelect?.addEventListener('change', update);
    update();
  });
});

// v12 account drawer, local My Garage, and recently viewed products.
document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.querySelector('.drawer-overlay');
  const accountDrawer = document.querySelector('#account-drawer');
  const garageDrawer = document.querySelector('#garage-drawer');

  // Move fixed drawers out of the sticky/backdrop-filter header.
  // Otherwise mobile Safari can treat the header as the fixed-position containing block,
  // clipping the top of the drawer and preventing users from scrolling back to it.
  [accountDrawer, garageDrawer, overlay].forEach(el => {
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
  });
  const accountToggle = document.querySelector('.account-toggle');
  const accountClose = document.querySelector('.account-close');
  const garageClose = document.querySelector('.garage-close');
  const garageToggle = document.querySelector('.garage-toggle');
  const wishlistSecondary = document.querySelector('.wishlist-toggle-secondary');
  const wishlistPrimary = document.querySelector('.wishlist-toggle');
  const closeAll = () => {
    [accountDrawer, garageDrawer].forEach(el => { if (el) el.hidden = true; });
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
    accountToggle?.setAttribute('aria-expanded','false');
  };
  const openDrawer = drawer => {
    closeAll();
    if (!drawer) return;
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  };
  accountToggle?.addEventListener('click', () => { openDrawer(accountDrawer); accountToggle.setAttribute('aria-expanded','true'); });
  accountClose?.addEventListener('click', closeAll);
  garageClose?.addEventListener('click', closeAll);
  overlay?.addEventListener('click', closeAll);
  garageToggle?.addEventListener('click', () => openDrawer(garageDrawer));
  wishlistSecondary?.addEventListener('click', () => { closeAll(); wishlistPrimary?.click(); });

  const RECENT_KEY='jfab_recent_v1';
  const current=document.querySelector('[data-current-product]');
  let recent=[]; try{recent=JSON.parse(localStorage.getItem(RECENT_KEY)||'[]')}catch{}
  if(current){
    const item={handle:current.dataset.productHandle,title:current.dataset.productTitle,url:current.dataset.productUrl,image:current.dataset.productImage,price:current.dataset.productPrice};
    recent=[item,...recent.filter(x=>x.handle!==item.handle)].slice(0,8); localStorage.setItem(RECENT_KEY,JSON.stringify(recent));
  }
  const section=document.querySelector('[data-recently-viewed-section]');
  const grid=document.querySelector('[data-recently-viewed-grid]');
  const shown=recent.filter(x=>!current||x.handle!==current.dataset.productHandle).slice(0,4);
  if(section&&grid&&shown.length){
    grid.innerHTML=shown.map(x=>`<a class="recent-card" href="${x.url}">${x.image?`<img src="${x.image}" alt="">`:''}<div><h3>${x.title}</h3><p>${x.price||''}</p></div></a>`).join('');
    section.hidden=false;
  }
});

// v117 exact Make -> Model -> Year -> Configuration selector and persistent, shoppable garage.
document.addEventListener('DOMContentLoaded', () => {
  const fitmentData = window.JFAB_FITMENT_DATA;
  const selectorForms = [...document.querySelectorAll('[data-jfab-fitment-selector]')];
  const garageList = document.querySelector('[data-garage-items]');
  const garageEmpty = document.querySelector('[data-garage-empty]');
  const accountVehicle = document.querySelector('[data-jfab-account-vehicle]');
  const GARAGE_KEY = 'jfab_garage_v1';
  const ACTIVE_KEY = 'jfab_active_vehicle_v1';

  const escapeHtml = value => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
  const slugify = value => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  const safeCollectionUrl = value => {
    const candidate = String(value || '');
    if (/^\/collections\/[a-z0-9-]+$/i.test(candidate)) return candidate;
    try {
      const parsed = new URL(candidate, window.location.origin);
      const allowedKeys = new Set(['make', 'model', 'year', 'view']);
      const keysAreSafe = [...parsed.searchParams.keys()].every(key => allowedKeys.has(key));
      const isMergedCfmotoFitment = parsed.origin === window.location.origin &&
        parsed.pathname === '/collections/sxs-cfmoto' &&
        parsed.searchParams.get('make') === 'cfmoto' &&
        /^jfab-fitment-group-cfmoto-[a-z0-9-]+$/.test(parsed.searchParams.get('model') || '') &&
        /^(?:19|20)\d{2}$/.test(parsed.searchParams.get('year') || '') &&
        parsed.searchParams.get('view') === 'fitment';
      return keysAreSafe && isMergedCfmotoFitment ? `${parsed.pathname}${parsed.search}` : '';
    } catch {
      return '';
    }
  };
  const readJson = (key, fallback) => {
    try {
      const parsed = JSON.parse(localStorage.getItem(key) || 'null');
      return parsed ?? fallback;
    } catch {
      return fallback;
    }
  };
  const getGarage = () => {
    const items = readJson(GARAGE_KEY, []);
    return Array.isArray(items) ? items.filter(item => item && typeof item === 'object') : [];
  };
  const saveGarage = items => {
    try { localStorage.setItem(GARAGE_KEY, JSON.stringify(items)); } catch {}
  };
  const getActive = () => {
    const active = readJson(ACTIVE_KEY, null);
    return active && typeof active === 'object' ? active : null;
  };
  const saveActive = item => {
    try {
      if (item) localStorage.setItem(ACTIVE_KEY, JSON.stringify(item));
      else localStorage.removeItem(ACTIVE_KEY);
    } catch {}
  };
  const vehicleLabel = item => [item?.year, item?.make, item?.model, item?.trim].filter(Boolean).join(' ');
  const itemIdentity = item => item?.key || [item?.year, item?.make, item?.model, item?.trim].map(value => String(value || '').toLowerCase()).join('|');

  const renderActive = () => {
    const active = getActive();
    const label = vehicleLabel(active);
    const url = safeCollectionUrl(active?.url);
    if (accountVehicle) accountVehicle.textContent = label ? `Active: ${label}` : 'Choose a vehicle to shop exact-fit parts.';
    document.querySelectorAll('[data-jfab-active-summary]').forEach(summary => {
      const form = summary.closest('[data-jfab-fitment-selector]');
      const scopedMake = slugify(form?.dataset.jfabInitialMake || '');
      const activeMatchesScope = !scopedMake || scopedMake === slugify(active?.make || '');
      const showSummary = Boolean(label && activeMatchesScope);
      summary.hidden = !showSummary;
      const labelNode = summary.querySelector('[data-jfab-active-summary-label]');
      const link = summary.querySelector('[data-jfab-active-summary-link]');
      if (labelNode) labelNode.textContent = showSummary ? label : '';
      if (link) {
        link.hidden = !showSummary || !url;
        link.href = url || '/collections/satv-sxs-utv-parts';
      }
    });
  };

  const renderGarage = () => {
    const items = getGarage();
    const active = getActive();
    const activeIdentity = itemIdentity(active);
    if (garageEmpty) garageEmpty.hidden = items.length > 0;
    if (!garageList) return;
    garageList.innerHTML = items.map((item, index) => {
      const label = vehicleLabel(item) || 'Saved vehicle';
      const url = safeCollectionUrl(item.url);
      const isActive = Boolean(url && activeIdentity && itemIdentity(item) === activeIdentity);
      return `<article class="garage-item${isActive ? ' is-active' : ''}">
        <div class="garage-item__vehicle">
          <strong>${escapeHtml(label)}</strong>
          <span>${url ? (isActive ? 'Active vehicle' : 'Exact-fit collection ready') : 'Re-select this vehicle to enable exact-fit shopping'}</span>
        </div>
        <div class="garage-item__actions">
          ${url ? `<a href="${escapeHtml(url)}">Shop Parts</a>` : ''}
          ${url && !isActive ? `<button type="button" data-garage-activate="${index}">Use Vehicle</button>` : ''}
          <button type="button" data-garage-remove="${index}" aria-label="Remove ${escapeHtml(label)}">Remove</button>
        </div>
      </article>`;
    }).join('');
  };

  const addExactVehicle = item => {
    const items = getGarage();
    const identity = itemIdentity(item);
    const existingIndex = items.findIndex(candidate => itemIdentity(candidate) === identity);
    if (existingIndex >= 0) items[existingIndex] = item;
    else items.push(item);
    saveGarage(items);
    saveActive(item);
    renderGarage();
    renderActive();
  };

  garageList?.addEventListener('click', event => {
    const remove = event.target.closest('[data-garage-remove]');
    if (remove) {
      const items = getGarage();
      const removed = items.splice(Number(remove.dataset.garageRemove), 1)[0];
      if (itemIdentity(removed) === itemIdentity(getActive())) saveActive(null);
      saveGarage(items);
      renderGarage();
      renderActive();
      return;
    }
    const activate = event.target.closest('[data-garage-activate]');
    if (activate) {
      const item = getGarage()[Number(activate.dataset.garageActivate)];
      if (safeCollectionUrl(item?.url)) {
        saveActive(item);
        renderGarage();
        renderActive();
      }
    }
  });

  if (!fitmentData?.makes?.length) {
    selectorForms.forEach(form => {
      const status = form.querySelector('[data-jfab-fitment-status]');
      if (status) status.textContent = 'Verified fitment data is unavailable. Browse all parts instead.';
    });
    renderGarage();
    renderActive();
    return;
  }

  const sxsMakeSlugs = new Set([
    'arctic-cat', 'axis', 'bad-boy', 'bennche', 'bobcat', 'can-am', 'cfmoto',
    'coleman', 'gravely', 'hisun', 'honda', 'john-deere', 'kawasaki', 'kayo',
    'kubota', 'kymco', 'mahindra', 'odes', 'polaris', 'rural-king', 'segway',
    'textron', 'tracker', 'vector', 'yamaha',
  ]);
  const sxsModelPatterns = Object.freeze({
    'can-am': /^(?:Commander|Defender|Defedner|Maverick|Traxter)\b/i,
    cfmoto: /^(?:U10|UForce|Z-Force|ZForce)\b/i,
    honda: /^(?:Pioneer|Talon)\b/i,
    kawasaki: /^(?:KRX4?|Mule|Ridge|Teryx[45]?)\b/i,
    polaris: /^(?:ACE|Brutus|EM1400|General|MRZR|Pro XD|Ranger|RZR|RZR2|RZR4|Xpedition)\b/i,
    segway: /^(?:Fugleman|UT10|Villain)\b/i,
    yamaha: /^(?:Rhino|Viking|Wolverine|YXZ)\b/i,
  });
  const yearRange = (first, last) =>
    Array.from({ length: last - first + 1 }, (_, index) => last - index);
  const canonicalRzrYears = new Map([
    ['jfab-fit-polaris-rzr-170-b9ff99334a', yearRange(2015, 2021)],
    ['jfab-fit-polaris-rzr-200-ff1079d227', yearRange(2022, 2026)],
    ['jfab-fit-polaris-rzr-570-9068bc4149', yearRange(2012, 2026)],
    ['jfab-fit-polaris-rzr-800-63996213f7', yearRange(2008, 2014)],
    ['jfab-fit-polaris-rzr-4-800-b117c2e22a', yearRange(2010, 2014)],
    ['jfab-fit-polaris-rzr-900-c59cadaa66', yearRange(2015, 2020)],
    ['jfab-fit-polaris-rzr-4-900-c3dacc31d9', yearRange(2015, 2018)],
    ['jfab-fit-polaris-rzr-trail-900-4b47fd8f58', yearRange(2021, 2026)],
    ['jfab-fit-polaris-rzr-s-1000-3a17f918c0', yearRange(2016, 2020)],
    ['jfab-fit-polaris-rzr-s4-1000-a584a56526', yearRange(2019, 2020)],
    ['jfab-fit-polaris-rzr-trail-s-1000-d040cb6850', yearRange(2021, 2026)],
    ['jfab-fit-polaris-rzr-xp-900-80cc7ed421', yearRange(2011, 2014)],
    ['jfab-fit-polaris-rzr-xp-4-900-aa5b4753f9', yearRange(2011, 2014)],
    ['jfab-fit-polaris-rzr-xp-1000-d2fe4bdb36', yearRange(2014, 2026)],
    ['jfab-fit-polaris-rzr-xp-4-1000-09a24bd821', yearRange(2014, 2026)],
    ['jfab-fit-polaris-rzr-xp-turbo-4e5f87b86b', yearRange(2016, 2021)],
    ['jfab-fit-polaris-rzr-xp-4-turbo-99f31f33fe', yearRange(2016, 2021)],
    ['jfab-fit-polaris-rzr-xp-turbo-s-055fc4e41f', yearRange(2018, 2021)],
    ['jfab-fit-polaris-rzr-xp-4-turbo-s-2271680aa5', yearRange(2019, 2021)],
    ['jfab-fit-polaris-rzr-pro-xp-d15e33cd6a', yearRange(2020, 2026)],
    ['jfab-fit-polaris-rzr-pro-xp-4-a69c17829f', yearRange(2020, 2026)],
    ['jfab-fit-polaris-rzr-turbo-r-94be7dc54e', yearRange(2022, 2026)],
    ['jfab-fit-polaris-rzr-turbo-r-4-efc7c7243e', yearRange(2022, 2026)],
    ['jfab-fit-polaris-rzr-pro-r-5f952dbe65', yearRange(2022, 2026)],
    ['jfab-fit-polaris-rzr-pro-r-4-0410bb6297', yearRange(2022, 2026)],
    ['jfab-fit-polaris-rzr-pro-s-2068b24405', yearRange(2025, 2026)],
    ['jfab-fit-polaris-rzr-pro-s-4-4cd52efd85', yearRange(2025, 2026)],
    ['jfab-fit-polaris-rzr-rs1-b82ceb4101', yearRange(2018, 2022)],
    ['jfab-fit-polaris-rzr-trail-570-ce89acfb47', yearRange(2021, 2026)],
  ]);
  const canonicalRzrHandles = new Set(canonicalRzrYears.keys());
  const correctedFitmentNames = new Map([
    ['Mule 600/61', 'Mule 600/610'],
  ]);
  // These typo aliases are separate published collections with additional,
  // non-overlapping products. Keep their routes while fixing and distinguishing
  // the customer-facing labels so no valid fitments are hidden.
  const correctedFitmentNamesByHandle = new Map([
    ['jfab-fit-can-am-defedner-max-hd-11-lone-star-cab-9099813ba7', 'Defender MAX HD 11 Lone Star Cab — Additional fitments'],
    ['jfab-fit-gravely-atlas-jvs-3400-e489846596', 'Atlas JSV 3400 — Additional fitments'],
    ['jfab-fit-gravely-atlas-jvs-6400-af399561e7', 'Atlas JSV 6400 — Additional fitments'],
    ['jfab-fit-honda-pioneer-1000-forrest-edition-9bb5adae66', 'Pioneer 1000 Forest Edition — Additional fitments'],
    ['jfab-fit-honda-pioneer-1000-5-forrest-edition-cc3f1fb56d', 'Pioneer 1000-5 Forest Edition — Additional fitments'],
    ['jfab-fit-cfmoto-uforce-u10-pro-56d69ffe7d', 'U10 Pro'],
    ['jfab-fit-cfmoto-uforce-u10-pro-highland-2a4cb2a47f', 'U10 Pro Highland'],
    ['jfab-fit-cfmoto-u10-xl-pro-48db956893', 'U10 Pro XL'],
    ['jfab-fit-cfmoto-uforce-u10-pro-xl-dcc19f553b', 'U10 Pro XL'],
    ['jfab-fit-cfmoto-u10-xl-pro-highland-a1bde18304', 'U10 Pro XL Highland'],
    ['jfab-fit-cfmoto-uforce-u10-pro-xl-highland-176cb454e6', 'U10 Pro XL Highland'],
    ['jfab-fit-cfmoto-uforce-xl-800-4dfb7243c2', 'UForce 800 XL'],
    ['jfab-fit-cfmoto-uforce-xl-1000-714f7146e3', 'UForce 1000 XL'],
    ['jfab-fit-cfmoto-z-force-800-28f9acd298', 'ZForce 800'],
    ['jfab-fit-cfmoto-zforce-800ex-a13b0c31c4', 'ZForce 800 EX'],
    ['jfab-fit-cfmoto-zforce-950-h-o-ex-d5866db816', 'ZForce 950 HO EX'],
    ['jfab-fit-cfmoto-zforce-950-4-sport-e35a1bffa9', 'ZForce 950 Sport 4'],
  ]);
  const canonicalKrxHandles = new Map([
    ['jfab-shop-kawasaki-krx-1000', 'jfab-fit-kawasaki-teryx-krx-1000-575a3b21e3'],
    ['jfab-shop-kawasaki-krx4-1000', 'jfab-fit-kawasaki-teryx-krx-4-1000-e2b43d1510'],
  ]);
  const verifiedKrxHandles = new Set(canonicalKrxHandles.values());
  const normalizeFitmentModel = (make, model) => {
    const originalName = String(model?.name || '').trim();
    const originalHandle = String(model?.handleBase || '');
    const correctedName = correctedFitmentNamesByHandle.get(originalHandle) || correctedFitmentNames.get(originalName);
    let normalizedModel = correctedName ? { ...model, name: correctedName } : model;
    const handleBase = String(normalizedModel?.handleBase || '');
    const canonicalKrxHandle = make.slug === 'kawasaki' ? canonicalKrxHandles.get(originalHandle) : null;
    if (canonicalKrxHandle) {
      normalizedModel = { ...normalizedModel, handleBase: canonicalKrxHandle, routes: {}, trims: {} };
    }
    if (make.slug === 'honda' && handleBase === 'jfab-fit-honda-talon-1000x-063bdc0c2b') {
      normalizedModel = { ...normalizedModel, years: (normalizedModel.years || []).filter(year => Number(year) !== 2018) };
    }
    if (make.slug === 'honda' && handleBase === 'jfab-fit-honda-pioneer-500-4c311fd14b') {
      normalizedModel = { ...normalizedModel, years: (normalizedModel.years || []).filter(year => Number(year) !== 2014) };
    }

    const canonicalYears = make.slug === 'polaris' ? canonicalRzrYears.get(handleBase) : null;
    if (!canonicalYears) return normalizedModel;
    const routes = { ...(normalizedModel.routes || {}) };
    if (
      handleBase === 'jfab-fit-polaris-rzr-xp-1000-d2fe4bdb36' ||
      handleBase === 'jfab-fit-polaris-rzr-xp-turbo-4e5f87b86b'
    ) {
      routes['2017'] = 'rzr-xp-1000-2017-2018';
      routes['2018'] = 'rzr-xp-1000-2017-2018';
    }
    return { ...normalizedModel, years: canonicalYears, routes };
  };
  const modelBelongsInSxs = (make, model) => {
    const name = String(model?.name || '').trim();
    const handleBase = String(model?.handleBase || '');
    if (make.slug === 'kawasaki' && (/\bKRX4?\b/i.test(name) || /(?:^|-)krx4?(?:-|$)/i.test(handleBase))) {
      return verifiedKrxHandles.has(handleBase);
    }
    if (
      make.slug === 'polaris' &&
      (/^RZR/i.test(name) || /(?:^|-)rzr(?:-|$)/i.test(handleBase))
    ) {
      return canonicalRzrHandles.has(handleBase);
    }
    const pattern = sxsModelPatterns[make.slug];
    return pattern ? pattern.test(name) : true;
  };
  const selectableMakes = fitmentData.makes
    .filter(make => sxsMakeSlugs.has(make.slug))
    .map(make => {
      const seenModels = new Set();
      const normalizedModels = (make.models || [])
        .map(model => normalizeFitmentModel(make, model))
        .filter(model => modelBelongsInSxs(make, model))
        .filter(model => {
          if (seenModels.has(model.handleBase)) return false;
          seenModels.add(model.handleBase);
          return true;
        });
      if (make.slug !== 'cfmoto') return { ...make, models: normalizedModels };

      const groupedModels = new Map();
      normalizedModels.forEach(model => {
        const key = String(model.name || '').trim().toLowerCase();
        if (!groupedModels.has(key)) groupedModels.set(key, []);
        groupedModels.get(key).push(model);
      });
      const models = [...groupedModels.values()].map(group => {
        if (group.length === 1) return group[0];
        const name = group[0].name;
        const years = [...new Set(group.flatMap(model => model.years || []).map(Number).filter(Boolean))].sort((a, b) => b - a);
        return {
          ...group[0],
          name,
          handleBase: `jfab-fitment-group-cfmoto-${slugify(name)}`,
          years,
          routes: {},
          trims: {},
          fitmentMembers: group,
        };
      });
      return { ...make, models };
    })
    .filter(make => make.models.length);
  // v123 photo-card flow: keep shoppers in place and reveal only the next choice.
  const cardPickerLinks = [...document.querySelectorAll('[data-jfab-model-card]')];
  let activeCardPicker = null;
  const closeCardPicker = () => {
    activeCardPicker?.link?.setAttribute('aria-expanded', 'false');
    activeCardPicker?.panel?.remove();
    activeCardPicker = null;
  };
  const routeForModelYear = (model, year, trim) => {
    if (model?.fitmentMembers?.length) {
      const query = new URLSearchParams({
        make: 'cfmoto',
        model: model.handleBase,
        year: String(year),
        view: 'fitment',
      });
      return `sxs-cfmoto?${query}`;
    }
    return trim?.handle || model?.routes?.[String(year)] || `${model?.handleBase}-${year}`;
  };
  const modelMatchesHandle = (model, handle) => model?.handleBase === handle ||
    Boolean(model?.fitmentMembers?.some(member => member.handleBase === handle));
  const modelsForCard = link => {
    const make = selectableMakes.find(entry => entry.slug === link.dataset.jfabModelMake);
    if (!make) return { make: null, models: [] };
    const requestedHandles = String(link.dataset.jfabModelHandles || '')
      .split(',')
      .map(value => value.trim())
      .filter(Boolean);
    const filterText = String(link.dataset.jfabModelFilter || '').trim().toLowerCase();
    let models = make.models || [];
    if (requestedHandles.length) {
      const requested = new Set(requestedHandles);
      const ordered = [];
      requestedHandles.forEach(handle => {
        const match = models.find(model => modelMatchesHandle(model, handle));
        if (match && !ordered.includes(match)) ordered.push(match);
      });
      models = ordered.length ? ordered : models.filter(model =>
        requested.has(model.handleBase) || model.fitmentMembers?.some(member => requested.has(member.handleBase))
      );
    } else if (filterText) {
      models = models.filter(model => String(model.name || '').toLowerCase().includes(filterText));
    }
    return { make, models };
  };
  const openCardPicker = link => {
    if (activeCardPicker?.link === link) {
      closeCardPicker();
      return;
    }
    const { make, models } = modelsForCard(link);
    if (!make || !models.length) return;
    closeCardPicker();

    const card = link.closest('.vehicle-shop-card');
    if (!card) return;
    const panel = document.createElement('section');
    panel.className = 'jfab-card-picker';
    panel.setAttribute('aria-label', `Choose exact ${make.name} model and year`);
    panel.innerHTML = `
      <div class="jfab-card-picker__header">
        <div>
          <span class="eyebrow">NEXT: EXACT FITMENT</span>
          <h3 tabindex="-1">Choose your exact ${escapeHtml(make.name)} model and year</h3>
        </div>
        <button type="button" class="jfab-card-picker__close" data-jfab-card-picker-close aria-label="Close exact vehicle choices">×</button>
      </div>
      <div class="jfab-card-picker__models" data-jfab-card-picker-models></div>
      <div class="jfab-card-picker__years" data-jfab-card-picker-years></div>
      <button type="button" class="jfab-card-picker__exact" data-jfab-open-exact>Need every model or configuration? Open the full selector</button>
    `;
    card.insertAdjacentElement('afterend', panel);
    link.setAttribute('aria-expanded', 'true');
    activeCardPicker = { link, panel };

    const modelHost = panel.querySelector('[data-jfab-card-picker-models]');
    const yearHost = panel.querySelector('[data-jfab-card-picker-years]');
    const renderYears = model => {
      if (!model || !yearHost) return;
      const years = [...new Set((model.years || []).map(Number).filter(Boolean))].sort((a, b) => b - a);
      yearHost.innerHTML = `<p>Choose year for <strong>${escapeHtml(model.name)}</strong></p><div class="jfab-card-picker__year-grid"></div>`;
      const yearGrid = yearHost.querySelector('.jfab-card-picker__year-grid');
      years.forEach(year => {
        const trims = model?.trims?.[String(year)] || [];
        if (trims.length) {
          const group = document.createElement('div');
          group.className = 'jfab-card-picker__trim-group';
          group.innerHTML = `<strong>${year}</strong>`;
          trims.forEach(trim => {
            const handle = routeForModelYear(model, year, trim);
            const url = safeCollectionUrl(`/collections/${handle}`);
            if (!url) return;
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.textContent = trim.label || trim.value || String(year);
            anchor.addEventListener('click', () => addExactVehicle({
              key: `${make.name}|${model.handleBase}|${year}|${trim.value || ''}`,
              make: make.name,
              model: model.name,
              modelHandleBase: model.handleBase,
              year,
              trim: trim.label || '',
              trimValue: trim.value || '',
              handle,
              url,
            }));
            group.append(anchor);
          });
          yearGrid?.append(group);
          return;
        }

        const handle = routeForModelYear(model, year);
        const url = safeCollectionUrl(`/collections/${handle}`);
        if (!url) return;
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.textContent = String(year);
        anchor.setAttribute('aria-label', `Shop ${year} ${make.name} ${model.name} parts`);
        anchor.addEventListener('click', () => addExactVehicle({
          key: `${make.name}|${model.handleBase}|${year}|`,
          make: make.name,
          model: model.name,
          modelHandleBase: model.handleBase,
          year,
          trim: '',
          trimValue: '',
          handle,
          url,
        }));
        yearGrid?.append(anchor);
      });
    };

    if (models.length === 1) {
      modelHost.innerHTML = `<p class="jfab-card-picker__selected-model"><strong>${escapeHtml(models[0].name)}</strong></p>`;
    } else if (models.length > 8) {
      const label = document.createElement('label');
      label.className = 'jfab-card-picker__model-select';
      label.innerHTML = '<span>Exact model</span>';
      const select = document.createElement('select');
      models.forEach((model, index) => select.add(new Option(model.name, String(index))));
      select.addEventListener('change', () => renderYears(models[Number(select.value)]));
      label.append(select);
      modelHost.append(label);
    } else {
      const buttons = document.createElement('div');
      buttons.className = 'jfab-card-picker__model-grid';
      models.forEach((model, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = model.name;
        button.classList.toggle('is-active', index === 0);
        button.addEventListener('click', () => {
          buttons.querySelectorAll('button').forEach(entry => entry.classList.toggle('is-active', entry === button));
          renderYears(model);
        });
        buttons.append(button);
      });
      modelHost.append(buttons);
    }

    renderYears(models[0]);
    panel.querySelector('[data-jfab-card-picker-close]')?.addEventListener('click', closeCardPicker);
    panel.querySelector('[data-jfab-open-exact]')?.addEventListener('click', () => {
      const details = panel.closest('.vehicle-shop-selector')?.querySelector('[data-jfab-exact-fitment]');
      if (details) details.open = true;
      closeCardPicker();
    });
    panel.querySelector('h3')?.focus({ preventScroll: true });
    window.requestAnimationFrame(() => panel.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  };

  cardPickerLinks.forEach(link => {
    link.setAttribute('aria-expanded', 'false');
    link.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const { make, models } = modelsForCard(link);
      if (!make || !models.length) return;
      event.preventDefault();
      openCardPicker(link);
    });
  });

  const params = new URLSearchParams(window.location.search);
  selectorForms.forEach(form => {
    const makeSelect = form.querySelector('select[name="make"]');
    const modelSelect = form.querySelector('select[name="model"]');
    const yearSelect = form.querySelector('select[name="year"]');
    const trimSelect = form.querySelector('select[name="trim"]');
    const trimField = form.querySelector('[data-jfab-fitment-trim-field]');
    const submit = form.querySelector('[data-jfab-fitment-submit]');
    const status = form.querySelector('[data-jfab-fitment-status]');
    if (!makeSelect || !modelSelect || !yearSelect || !submit) return;
    const formSelectableMakes = selectableMakes;

    const setOptions = (select, placeholder, entries) => {
      select.replaceChildren(new Option(placeholder, ''));
      entries.forEach(entry => select.add(new Option(entry.label, entry.value)));
    };
    const selectedMake = () => formSelectableMakes.find(make => make.slug === makeSelect.value);
    const selectedModel = () => selectedMake()?.models.find(model => model.handleBase === modelSelect.value);
    const trimsFor = (model, year) => model?.trims?.[String(year)] || [];
    const selectedTrim = (model, year) => trimsFor(model, year).find(trim => trim.value === trimSelect?.value);
    const collectionHandle = (model, year, trim) => routeForModelYear(model, year, trim);
    const updateReadyState = () => {
      const make = selectedMake();
      const model = selectedModel();
      const year = Number(yearSelect.value);
      const trims = trimsFor(model, year);
      const trim = selectedTrim(model, year);
      const ready = Boolean(make && model && model.years.includes(year) && (!trims.length || trim));
      submit.disabled = !ready;
      if (status) {
        if (ready) {
          status.textContent = `${year} ${make.name} ${model.name}${trim ? ` · ${trim.label}` : ''} has verified active parts.`;
        } else if (make && model && model.years.includes(year) && trims.length) {
          status.textContent = 'Choose the exact KRX4 configuration to see verified parts.';
        } else {
          status.textContent = 'Choose Make, Model, then Year to see exact-fit parts.';
        }
      }
    };
    const populateTrims = preferredTrim => {
      if (!trimSelect || !trimField) {
        updateReadyState();
        return;
      }
      const model = selectedModel();
      const year = Number(yearSelect.value);
      const trims = trimsFor(model, year);
      setOptions(trimSelect, 'Choose configuration', trims.map(trim => ({ label: trim.label, value: trim.value })));
      const hasTrims = trims.length > 0;
      trimField.hidden = !hasTrims;
      trimSelect.disabled = !hasTrims;
      trimSelect.required = hasTrims;
      form.classList.toggle('has-trim', hasTrims);
      if (preferredTrim && trims.some(trim => trim.value === preferredTrim)) trimSelect.value = preferredTrim;
      updateReadyState();
    };
    const populateYears = (preferredYear, preferredTrim = '') => {
      const model = selectedModel();
      const years = model?.years || [];
      setOptions(yearSelect, 'Choose year', years.map(year => ({ label: String(year), value: String(year) })));
      yearSelect.disabled = years.length === 0;
      if (preferredYear && years.includes(Number(preferredYear))) yearSelect.value = String(preferredYear);
      populateTrims(preferredTrim);
    };
    const populateModels = (preferredModel, preferredYear, preferredTrim = '') => {
      const make = selectedMake();
      const models = make?.models || [];
      setOptions(modelSelect, 'Choose model', models.map(model => ({ label: model.name, value: model.handleBase })));
      modelSelect.disabled = models.length === 0;
      if (preferredModel && models.some(model => model.handleBase === preferredModel)) modelSelect.value = preferredModel;
      populateYears(preferredYear, preferredTrim);
    };

    setOptions(makeSelect, 'Choose make', formSelectableMakes.map(make => ({ label: make.name, value: make.slug })));
    makeSelect.disabled = false;
    makeSelect.addEventListener('change', () => populateModels('', '', ''));
    modelSelect.addEventListener('change', () => populateYears('', ''));
    yearSelect.addEventListener('change', () => populateTrims(''));
    trimSelect?.addEventListener('change', updateReadyState);

    const active = getActive();
    const requestedMake = params.get('make') || form.dataset.jfabInitialMake || active?.make || '';
    const make = formSelectableMakes.find(entry => entry.slug === slugify(requestedMake));
    if (make) {
      makeSelect.value = make.slug;
      const useActiveDetail = slugify(active?.make) === make.slug;
      const requestedModel = params.get('model') || (useActiveDetail ? active?.modelHandleBase : '');
      const requestedYear = params.get('year') || (useActiveDetail ? active?.year : '');
      const requestedTrim = params.get('trim') || (useActiveDetail ? active?.trimValue : '');
      populateModels(requestedModel, requestedYear, requestedTrim);
    } else {
      populateModels('', '', '');
    }

    form.addEventListener('submit', event => {
      event.preventDefault();
      const makeEntry = selectedMake();
      const modelEntry = selectedModel();
      const year = Number(yearSelect.value);
      if (!makeEntry || !modelEntry || !modelEntry.years.includes(year)) return;
      const trims = trimsFor(modelEntry, year);
      const trimEntry = selectedTrim(modelEntry, year);
      if (trims.length && !trimEntry) return;
      const handle = collectionHandle(modelEntry, year, trimEntry);
      const url = safeCollectionUrl(`/collections/${handle}`);
      if (!url) return;
      const item = {
        key: `${makeEntry.name}|${modelEntry.handleBase}|${year}|${trimEntry?.value || ''}`,
        make: makeEntry.name,
        model: modelEntry.name,
        modelHandleBase: modelEntry.handleBase,
        year,
        trim: trimEntry?.label || '',
        trimValue: trimEntry?.value || '',
        handle,
        url,
      };
      addExactVehicle(item);
      window.location.assign(url);
    });
  });

  const renderMergedCfmotoResults = async () => {
    const isCfmotoPage = window.location.pathname.replace(/\/+$/, '').endsWith('/collections/sxs-cfmoto');
    if (!isCfmotoPage || params.get('view') !== 'fitment' || params.get('make') !== 'cfmoto') return;

    const year = Number(params.get('year'));
    const cfmoto = selectableMakes.find(make => make.slug === 'cfmoto');
    const model = cfmoto?.models?.find(entry => entry.handleBase === params.get('model'));
    if (!model?.fitmentMembers?.length || !model.years.includes(year)) return;

    const selectorSection = document.querySelector('.vehicle-shop-selector');
    if (!selectorSection) return;
    const results = document.createElement('section');
    results.className = 'section section-light jfab-merged-fitment-results';
    results.setAttribute('aria-labelledby', 'jfab-merged-fitment-title');
    results.innerHTML = `
      <div class="container">
        <div class="vehicle-shop-heading">
          <p class="eyebrow">EXACT FITMENT</p>
          <h2 id="jfab-merged-fitment-title">${escapeHtml(year)} ${escapeHtml(cfmoto.name)} ${escapeHtml(model.name)} Parts</h2>
          <p data-jfab-merged-fitment-status>Loading every matching part…</p>
        </div>
        <div class="card-grid" data-jfab-merged-fitment-grid hidden></div>
      </div>
    `;
    selectorSection.insertAdjacentElement('afterend', results);

    const status = results.querySelector('[data-jfab-merged-fitment-status]');
    const grid = results.querySelector('[data-jfab-merged-fitment-grid]');
    const collectionHandles = model.fitmentMembers
      .filter(member => (member.years || []).map(Number).includes(year))
      .map(member => member.routes?.[String(year)] || `${member.handleBase}-${year}`);

    const requests = await Promise.allSettled(collectionHandles.map(async handle => {
      const matching = [];
      for (let page = 1; page <= 100; page += 1) {
        const response = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`, {
          credentials: 'same-origin', headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`Fitment collection ${handle} returned ${response.status}`);
        const payload = await response.json();
        if (!Array.isArray(payload?.products)) throw new Error('Invalid matching products');
        matching.push(...payload.products);
        if (payload.products.length < 250) return matching;
      }
      throw new Error('Matching collection exceeds pagination capacity');
    }));

    if (requests.some(request => request.status === 'rejected')) {
      if (status) status.textContent = 'Matching parts could not be loaded. Refresh this page to try again.';
      return;
    }
    const productsByHandle = new Map();
    requests.forEach(request => {
      if (request.status !== 'fulfilled') return;
      request.value.forEach(product => {
        if (product?.handle && !productsByHandle.has(product.handle)) productsByHandle.set(product.handle, product);
      });
    });
    const products = [...productsByHandle.values()].sort((a, b) => {
      const aAvailable = (a.variants || []).some(variant => variant.available);
      const bAvailable = (b.variants || []).some(variant => variant.available);
      if (aAvailable !== bAvailable) return aAvailable ? -1 : 1;
      return String(a.title || '').localeCompare(String(b.title || ''));
    });

    if (!products.length) {
      if (status) status.textContent = requests.some(request => request.status === 'rejected')
        ? 'Matching parts could not be loaded. Refresh this page to try again.'
        : 'No matching parts are currently available.';
      return;
    }

    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    grid.innerHTML = products.map(product => {
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const prices = variants.map(variant => Number(variant.price)).filter(Number.isFinite);
      const minimumPrice = prices.length ? Math.min(...prices) : null;
      const maximumPrice = prices.length ? Math.max(...prices) : null;
      const price = minimumPrice === null ? '' : `${maximumPrice > minimumPrice ? 'From ' : ''}${money.format(minimumPrice)}`;
      const available = variants.some(variant => variant.available);
      const image = product.images?.[0]?.src || product.image?.src || '';
      const url = `/products/${encodeURIComponent(product.handle)}`;
      return `<article class="card store-card" data-jfab-product-card data-jfab-product-handle="${escapeHtml(product.handle)}" data-jfab-filter-text="${escapeHtml([product.product_type, product.title, ...(product.tags || [])].join('|'))}" data-jfab-title="${escapeHtml(product.title || '')}" data-jfab-price="${minimumPrice === null ? '' : Math.round(minimumPrice * 100)}" data-jfab-variants="${escapeHtml(JSON.stringify(variants.map(variant => ({ price: Math.round(Number(variant.price) * 100), available: Boolean(variant.available) }))))}">
        <div class="card-body">
          <span class="status">${available ? 'AVAILABLE' : 'SOLD OUT'}</span>
          <h3><a href="${url}">${escapeHtml(product.title || 'Product')}</a></h3>
          <div class="card-media light">${image ? `<img src="${escapeHtml(image)}" loading="lazy" alt="${escapeHtml(product.title || 'Product')}">` : ''}</div>
          ${price ? `<p class="price">${escapeHtml(price)}</p>` : ''}
          <div class="card-actions"><a class="button button-primary" href="${url}">View Details</a></div>
        </div>
      </article>`;
    }).join('');
    grid.hidden = false;
    if (status) status.textContent = `${products.length} matching part${products.length === 1 ? '' : 's'}`;
    const filterTemplate = document.querySelector('[data-jfab-merged-facets]');
    if (filterTemplate) {
      grid.before(filterTemplate.content.cloneNode(true));
      document.dispatchEvent(new CustomEvent('jfab:merged-results-ready'));
    }

    window.requestAnimationFrame(() => results.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  };

  renderMergedCfmotoResults();

  renderGarage();
  renderActive();
});


// v74 carries the selected vehicle into launch-list and product-request forms.
document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const vehicle = (params.get('vehicle') || '').trim();
  const rawYears = (params.get('years') || '').trim();
  const years = rawYears
    .replace(/\s*·\s*fitment not yet verified.*$/i, '')
    .replace(/\s*·\s*model fitment pending verification.*$/i, '')
    .trim();
  const vehicleType = (params.get('type') || '').trim();
  const make = (params.get('make') || '').trim();
  const hasVehicleContext = Boolean(vehicle || years || vehicleType || make);

  const selectMatchingOption = (select, value) => {
    if (!select || !value) return;
    const normalized = value.toLowerCase();
    const option = [...select.options].find(item =>
      item.value.toLowerCase() === normalized || item.textContent.trim().toLowerCase() === normalized
    );
    if (option) select.value = option.value;
  };
  const fillIfBlank = (element, value) => {
    if (element && value && !element.value) element.value = value;
  };

  const requestForm = document.querySelector('#request-product-form');
  if (requestForm && hasVehicleContext) {
    selectMatchingOption(requestForm.querySelector('[data-prefill-request-type]'), 'Add a new part for an existing vehicle');
    selectMatchingOption(requestForm.querySelector('[data-prefill-type]'), vehicleType);
    fillIfBlank(requestForm.querySelector('[data-prefill-years]'), years);
    fillIfBlank(requestForm.querySelector('[data-prefill-make]'), make);

    const modelValue = vehicle && vehicle.toLowerCase() !== make.toLowerCase() ? vehicle : '';
    fillIfBlank(requestForm.querySelector('[data-prefill-model]'), modelValue);
    fillIfBlank(
      requestForm.querySelector('[data-prefill-product]'),
      vehicle ? `${vehicle} products` : (make ? `${make} products` : '')
    );

    const summary = requestForm.querySelector('[data-request-prefill-summary]');
    if (summary) {
      const selected = [make, modelValue, years].filter(Boolean).join(' · ');
      summary.textContent = `Selected vehicle: ${selected || vehicle}. Add any details below.`;
      summary.hidden = false;
    }
  }

  const launchForm = document.querySelector('#launch-list-form');
  if (!launchForm) return;
  const interest = launchForm.querySelector('[data-launch-interest]');
  const vehicleFields = launchForm.querySelector('[data-launch-vehicle-fields]');
  const vehicleInput = launchForm.querySelector('[data-launch-vehicle]');
  const yearsInput = launchForm.querySelector('[data-launch-years]');
  const noteInput = launchForm.querySelector('[data-launch-note]');

  if (hasVehicleContext) {
    selectMatchingOption(interest, 'Powersports products');
    if (vehicleFields) vehicleFields.hidden = false;
    fillIfBlank(vehicleInput, [make, vehicle].filter((value, index, list) => value && list.indexOf(value) === index).join(' '));
    fillIfBlank(yearsInput, years);
  }

  const updateLaunchNote = () => {
    if (!noteInput) return;
    const parts = [`Primary interest: ${interest?.value || 'General J Fab updates'}`];
    if (vehicleInput?.value.trim()) parts.push(`Vehicle: ${vehicleInput.value.trim()}`);
    if (yearsInput?.value.trim()) parts.push(`Years: ${yearsInput.value.trim()}`);
    if (vehicleType) parts.push(`Vehicle type: ${vehicleType}`);
    noteInput.value = parts.join(' | ');
  };
  [interest, vehicleInput, yearsInput].forEach(element => {
    element?.addEventListener('input', updateLaunchNote);
    element?.addEventListener('change', updateLaunchNote);
  });
  updateLaunchNote();
});
